export default {
  AUTHENTICATE: 'AUTHENTICATE',
  CLEAR_USER: 'LOGOUT',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_CURRENT_USER_AVAILABILITY: 'SET_CURRENT_USER_AVAILABILITY',
  SET_CURRENT_USER_UI_SETTINGS: 'SET_CURRENT_USER_UI_SETTINGS',
  SET_CURRENT_USER_UI_FLAGS: 'SET_CURRENT_USER_UI_FLAGS',

  // Chat List
  RECEIVE_CHAT_LIST: 'RECEIVE_CHAT_LIST',
  SET_ALL_CONVERSATION: 'SET_ALL_CONVERSATION',
  EMPTY_ALL_CONVERSATION: 'EMPTY_ALL_CONVERSATION',
  SET_CONV_TAB_META: 'SET_CONV_TAB_META',
  SET_ACTIVE_CONV_STATS_CONTEXT: 'SET_ACTIVE_CONV_STATS_CONTEXT',
  CLEAR_LIST_LOADING_STATUS: 'CLEAR_LIST_LOADING_STATUS',
  SET_LIST_LOADING_STATUS: 'SET_LIST_LOADING_STATUS',
  SET_LIST_FETCH_FAILED: 'SET_LIST_FETCH_FAILED',
  SET_ALL_MESSAGES_LOADED: 'SET_ALL_MESSAGES_LOADED',
  CLEAR_ALL_MESSAGES_LOADED: 'CLEAR_ALL_MESSAGES_LOADED',
  CHANGE_CHAT_STATUS_FILTER: 'CHANGE_CHAT_STATUS_FILTER',
  CHANGE_CHAT_SORT_FILTER: 'CHANGE_CHAT_SORT_FILTER',
  UPDATE_ASSIGNEE: 'UPDATE_ASSIGNEE',
  UPDATE_CONVERSATION_CONTACT: 'UPDATE_CONVERSATION_CONTACT',
  CLEAR_CONTACT_CONVERSATIONS: 'CLEAR_CONTACT_CONVERSATIONS',
  SET_CONVERSATION_FILTERS: 'SET_CONVERSATION_FILTERS',
  CLEAR_CONVERSATION_FILTERS: 'CLEAR_CONVERSATION_FILTERS',
  SET_CONVERSATION_LAST_SEEN: 'SET_CONVERSATION_LAST_SEEN',
  SET_LAST_MESSAGE_ID_IN_SYNC_CONVERSATION:
    'SET_LAST_MESSAGE_ID_FOR_SYNC_CONVERSATION',
  SET_DRAFT_MESSAGES: 'SET_DRAFT_MESSAGES',
  REMOVE_DRAFT_MESSAGES: 'REMOVE_DRAFT_MESSAGES',
  SET_REPLY_EDITOR_MODE: 'SET_REPLY_EDITOR_MODE',

  SET_CURRENT_CHAT_WINDOW: 'SET_CURRENT_CHAT_WINDOW',
  CLEAR_CURRENT_CHAT_WINDOW: 'CLEAR_CURRENT_CHAT_WINDOW',
  CLEAR_ALL_MESSAGES: 'CLEAR_ALL_MESSAGES',
  CHANGE_CONVERSATION_STATUS: 'CHANGE_CONVERSATION_STATUS',
  ADD_CONVERSATION: 'ADD_CONVERSATION',
  UPDATE_CONVERSATION: 'UPDATE_CONVERSATION',
  MUTE_CONVERSATION: 'MUTE_CONVERSATION',
  UNMUTE_CONVERSATION: 'UNMUTE_CONVERSATION',
  ASSIGN_AGENT: 'ASSIGN_AGENT',
  ASSIGN_TEAM: 'ASSIGN_TEAM',
  ASSIGN_PRIORITY: 'ASSIGN_PRIORITY',
  SET_CONVERSATION_PINNED: 'SET_CONVERSATION_PINNED',
  SET_CHAT_META: 'SET_CHAT_META',
  ADD_MESSAGE: 'ADD_MESSAGE',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  ADD_PENDING_MESSAGE: 'ADD_PENDING_MESSAGE',
  UPDATE_MESSAGE_UNREAD_COUNT: 'UPDATE_MESSAGE_UNREAD_COUNT',
  SET_PREVIOUS_CONVERSATIONS: 'SET_PREVIOUS_CONVERSATIONS',
  SET_ACTIVE_INBOX: 'SET_ACTIVE_INBOX',
  UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES:
    'UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES',
  UPDATE_CONVERSATION_LAST_ACTIVITY: 'UPDATE_CONVERSATION_LAST_ACTIVITY',
  SET_MISSING_MESSAGES: 'SET_MISSING_MESSAGES',

  SET_ALL_ATTACHMENTS: 'SET_ALL_ATTACHMENTS',
  ADD_CONVERSATION_ATTACHMENTS: 'ADD_CONVERSATION_ATTACHMENTS',
  DELETE_CONVERSATION_ATTACHMENTS: 'DELETE_CONVERSATION_ATTACHMENTS',

  SET_CONVERSATION_CAN_REPLY: 'SET_CONVERSATION_CAN_REPLY',

  SET_CONTEXT_MENU_CHAT_ID: 'SET_CONTEXT_MENU_CHAT_ID',

  SET_CHAT_LIST_FILTERS: 'SET_CHAT_LIST_FILTERS',
  UPDATE_CHAT_LIST_FILTERS: 'UPDATE_CHAT_LIST_FILTERS',
  SET_FILTER_RESULT_IDS: 'SET_FILTER_RESULT_IDS',
  CLEAR_FILTER_RESULT_IDS: 'CLEAR_FILTER_RESULT_IDS',

  // Inboxes
  SET_INBOXES_UI_FLAG: 'SET_INBOXES_UI_FLAG',
  SET_INBOXES: 'SET_INBOXES',
  SET_INBOXES_ITEM: 'SET_INBOXES_ITEM',
  ADD_INBOXES: 'ADD_INBOXES',
  EDIT_INBOXES: 'EDIT_INBOXES',
  MERGE_INBOXES: 'MERGE_INBOXES',
  DELETE_INBOXES: 'DELETE_INBOXES',

  // Agent
  SET_ACCOUNT_UI_FLAG: 'SET_ACCOUNT_UI_FLAG',
  SET_ACCOUNT_LIMITS: 'SET_ACCOUNT_LIMITS',
  SET_ACCOUNTS: 'SET_ACCOUNTS',
  ADD_ACCOUNT: 'ADD_ACCOUNT',
  EDIT_ACCOUNT: 'EDIT_ACCOUNT',
  DELETE_ACCOUNT: 'DELETE_AGENT',

  // Agent
  SET_AGENT_FETCHING_STATUS: 'SET_AGENT_FETCHING_STATUS',
  SET_AGENT_CREATING_STATUS: 'SET_AGENT_CREATING_STATUS',
  SET_AGENT_UPDATING_STATUS: 'SET_AGENT_UPDATING_STATUS',
  SET_AGENT_DELETING_STATUS: 'SET_AGENT_DELETING_STATUS',
  SET_AGENTS: 'SET_AGENTS',
  ADD_AGENT: 'ADD_AGENT',
  EDIT_AGENT: 'EDIT_AGENT',
  DELETE_AGENT: 'DELETE_AGENT',
  UPDATE_AGENTS_PRESENCE: 'UPDATE_AGENTS_PRESENCE',
  UPDATE_SINGLE_AGENT_PRESENCE: 'UPDATE_SINGLE_AGENT_PRESENCE',

  // Canned Response
  SET_CANNED_UI_FLAG: 'SET_CANNED_UI_FLAG',
  SET_CANNED: 'SET_CANNED',
  ADD_CANNED: 'ADD_CANNED',
  EDIT_CANNED: 'EDIT_CANNED',
  DELETE_CANNED: 'DELETE_CANNED',

  // Custom Role
  SET_CUSTOM_ROLE_UI_FLAG: 'SET_CUSTOM_ROLE_UI_FLAG',
  SET_CUSTOM_ROLE: 'SET_CUSTOM_ROLE',
  ADD_CUSTOM_ROLE: 'ADD_CUSTOM_ROLE',
  EDIT_CUSTOM_ROLE: 'EDIT_CUSTOM_ROLE',
  DELETE_CUSTOM_ROLE: 'DELETE_CUSTOM_ROLE',
  SET_COPIED_CUSTOM_ROLE_PERMISSIONS: 'SET_COPIED_CUSTOM_ROLE_PERMISSIONS',

  // Labels
  SET_LABEL_UI_FLAG: 'SET_LABEL_UI_FLAG',
  SET_LABELS: 'SET_LABELS',
  ADD_LABEL: 'ADD_LABEL',
  EDIT_LABEL: 'EDIT_LABEL',
  DELETE_LABEL: 'DELETE_LABEL',

  // Integrations
  SET_INTEGRATIONS_UI_FLAG: 'SET_INTEGRATIONS_UI_FLAG',
  SET_INTEGRATIONS: 'SET_INTEGRATIONS',
  ADD_INTEGRATION: 'ADD_INTEGRATION',
  DELETE_INTEGRATION: 'DELETE_INTEGRATION',
  ADD_INTEGRATION_HOOKS: 'ADD_INTEGRATION_HOOKS',
  DELETE_INTEGRATION_HOOKS: 'DELETE_INTEGRATION_HOOKS',

  // WebHook
  SET_WEBHOOK_UI_FLAG: 'SET_WEBHOOK_UI_FLAG',
  SET_WEBHOOK: 'SET_WEBHOOK',
  ADD_WEBHOOK: 'ADD_WEBHOOK',
  DELETE_WEBHOOK: 'DELETE_WEBHOOK',
  UPDATE_WEBHOOK: 'UPDATE_WEBHOOK',

  // Contacts
  SET_CONTACT_META: 'SET_CONTACT_META',
  SET_CONTACT_UI_FLAG: 'SET_CONTACT_UI_FLAG',
  SET_CONTACT_ITEM: 'SET_CONTACT_ITEM',
  SET_CONTACTS: 'SET_CONTACTS',
  CLEAR_CONTACTS: 'CLEAR_CONTACTS',
  EDIT_CONTACT: 'EDIT_CONTACT',
  DELETE_CONTACT: 'DELETE_CONTACT',
  UPDATE_CONTACTS_PRESENCE: 'UPDATE_CONTACTS_PRESENCE',
  SET_CONTACT_FILTERS: 'SET_CONTACT_FILTERS',
  CLEAR_CONTACT_FILTERS: 'CLEAR_CONTACT_FILTERS',

  // Companies
  SET_COMPANY_META: 'SET_COMPANY_META',
  SET_COMPANY_WALLET_META: 'SET_COMPANY_WALLET_META',
  SET_COMPANY_UI_FLAG: 'SET_COMPANY_UI_FLAG',
  SET_COMPANY_PROFILE_UI_FLAG: 'SET_COMPANY_PROFILE_UI_FLAG',
  SET_COMPANY_ITEM: 'SET_COMPANY_ITEM',
  SET_CURRENT_COMPANY: 'SET_CURRENT_COMPANY',
  SET_COMPANY_ASSOCIATIONS: 'SET_COMPANY_ASSOCIATIONS',
  ADD_COMPANY_ASSOCIATION: 'ADD_COMPANY_ASSOCIATION',
  EDIT_COMPANY_ASSOCIATION: 'EDIT_COMPANY_ASSOCIATION',
  DELETE_COMPANY_ASSOCIATION: 'DELETE_COMPANY_ASSOCIATION',
  SET_COMPANY_NOTES: 'SET_COMPANY_NOTES',
  ADD_COMPANY_NOTE: 'ADD_COMPANY_NOTE',
  EDIT_COMPANY_NOTE: 'EDIT_COMPANY_NOTE',
  DELETE_COMPANY_NOTE: 'DELETE_COMPANY_NOTE',
  SET_COMPANY_ACTIVITY_EVENTS: 'SET_COMPANY_ACTIVITY_EVENTS',
  SET_COMPANY_TASKS: 'SET_COMPANY_TASKS',
  ADD_COMPANY_TASK: 'ADD_COMPANY_TASK',
  EDIT_COMPANY_TASK: 'EDIT_COMPANY_TASK',
  DELETE_COMPANY_TASK: 'DELETE_COMPANY_TASK',
  SET_COMPANIES: 'SET_COMPANIES',
  CLEAR_COMPANIES: 'CLEAR_COMPANIES',
  SET_COMPANY_WALLET: 'SET_COMPANY_WALLET',
  CLEAR_COMPANY_WALLET: 'CLEAR_COMPANY_WALLET',
  APPLY_COMPANY_BULK_CHANGES: 'APPLY_COMPANY_BULK_CHANGES',
  EDIT_COMPANY: 'EDIT_COMPANY',
  DELETE_COMPANY: 'DELETE_COMPANY',
  SET_SELECTED_COMPANY_IDS: 'SET_SELECTED_COMPANY_IDS',
  CLEAR_SELECTED_COMPANY_IDS: 'CLEAR_SELECTED_COMPANY_IDS',
  SET_COMPANY_FILTERS: 'SET_COMPANY_FILTERS',
  CLEAR_COMPANY_FILTERS: 'CLEAR_COMPANY_FILTERS',

  // Franchises
  SET_FRANCHISE_UI_FLAG: 'SET_FRANCHISE_UI_FLAG',
  CLEAR_FRANCHISES: 'CLEAR_FRANCHISES',
  SET_FRANCHISES: 'SET_FRANCHISES',
  SET_ALL_FRANCHISES: 'SET_ALL_FRANCHISES',
  SET_FRANCHISE_META: 'SET_FRANCHISE_META',
  SET_FRANCHISE_ITEM: 'SET_FRANCHISE_ITEM',
  SET_CURRENT_FRANCHISE: 'SET_CURRENT_FRANCHISE',
  EDIT_FRANCHISE: 'EDIT_FRANCHISE',
  DELETE_FRANCHISE: 'DELETE_FRANCHISE',
  SET_SELECTED_FRANCHISE_IDS: 'SET_SELECTED_FRANCHISE_IDS',
  CLEAR_SELECTED_FRANCHISE_IDS: 'CLEAR_SELECTED_FRANCHISE_IDS',

  // Franchise Units
  SET_FRANCHISE_UNITS: 'SET_FRANCHISE_UNITS',
  SET_FRANCHISE_ALL_UNITS: 'SET_FRANCHISE_ALL_UNITS',
  ADD_FRANCHISE_UNIT: 'ADD_FRANCHISE_UNIT',
  UPDATE_FRANCHISE_UNIT: 'UPDATE_FRANCHISE_UNIT',
  DELETE_FRANCHISE_UNIT: 'DELETE_FRANCHISE_UNIT',

  // Franchise Attendants
  SET_FRANCHISE_ATTENDANTS: 'SET_FRANCHISE_ATTENDANTS',
  ADD_FRANCHISE_ATTENDANT: 'ADD_FRANCHISE_ATTENDANT',
  DELETE_FRANCHISE_ATTENDANT: 'DELETE_FRANCHISE_ATTENDANT',

  // Franchise UI flags for units/attendants
  SET_FRANCHISE_UNITS_UI_FLAG: 'SET_FRANCHISE_UNITS_UI_FLAG',
  SET_FRANCHISE_ATTENDANTS_UI_FLAG: 'SET_FRANCHISE_ATTENDANTS_UI_FLAG',

  // Notifications
  SET_NOTIFICATIONS_META: 'SET_NOTIFICATIONS_META',
  SET_NOTIFICATIONS_SUMMARY: 'SET_NOTIFICATIONS_SUMMARY',
  SET_NOTIFICATIONS_UNREAD_COUNT: 'SET_NOTIFICATIONS_UNREAD_COUNT',
  SET_NOTIFICATIONS_UI_FLAG: 'SET_NOTIFICATIONS_UI_FLAG',
  UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
  READ_NOTIFICATION: 'READ_NOTIFICATION',
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  DELETE_NOTIFICATION: 'DELETE_NOTIFICATION',
  UPDATE_ALL_NOTIFICATIONS: 'UPDATE_ALL_NOTIFICATIONS',
  SET_NOTIFICATIONS_ITEM: 'SET_NOTIFICATIONS_ITEM',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
  CLEAR_NOTIFICATIONS: 'CLEAR_NOTIFICATIONS',
  EDIT_NOTIFICATIONS: 'EDIT_NOTIFICATIONS',
  UPDATE_NOTIFICATIONS_PRESENCE: 'UPDATE_NOTIFICATIONS_PRESENCE',
  SET_ALL_NOTIFICATIONS_LOADED: 'SET_ALL_NOTIFICATIONS_LOADED',
  DELETE_READ_NOTIFICATIONS: 'DELETE_READ_NOTIFICATIONS',
  DELETE_ALL_NOTIFICATIONS: 'DELETE_ALL_NOTIFICATIONS',
  SNOOZE_NOTIFICATION: 'SNOOZE_NOTIFICATION',
  SET_NOTIFICATION_FILTERS: 'SET_NOTIFICATION_FILTERS',
  UPDATE_NOTIFICATION_FILTERS: 'UPDATE_NOTIFICATION_FILTERS',

  // Contact Conversation
  SET_CONTACT_CONVERSATIONS_UI_FLAG: 'SET_CONTACT_CONVERSATIONS_UI_FLAG',
  SET_CONTACT_CONVERSATIONS: 'SET_CONTACT_CONVERSATIONS',
  ADD_CONTACT_CONVERSATION: 'ADD_CONTACT_CONVERSATION',
  DELETE_CONTACT_CONVERSATION: 'DELETE_CONTACT_CONVERSATION',

  // Contact Label
  SET_CONTACT_LABELS_UI_FLAG: 'SET_CONTACT_LABELS_UI_FLAG',
  SET_CONTACT_LABELS: 'SET_CONTACT_LABELS',

  // Conversation Label
  SET_CONVERSATION_LABELS_UI_FLAG: 'SET_CONVERSATION_LABELS_UI_FLAG',
  SET_CONVERSATION_LABELS: 'SET_CONVERSATION_LABELS',
  SET_BULK_CONVERSATION_LABELS: 'SET_BULK_CONVERSATION_LABELS',
  SET_SELECTED_CONVERSATION_IDS: 'SET_SELECTED_CONVERSATION_IDS',
  CLEAR_SELECTED_CONVERSATION_IDS: 'CLEAR_SELECTED_CONVERSATION_IDS',
  REMOVE_SELECTED_CONVERSATION_IDS: 'REMOVE_SELECTED_CONVERSATION_IDS',

  // Reports
  SET_ACCOUNT_REPORTS: 'SET_ACCOUNT_REPORTS',
  SET_HEATMAP_DATA: 'SET_HEATMAP_DATA',
  TOGGLE_HEATMAP_LOADING: 'TOGGLE_HEATMAP_LOADING',
  SET_ACCOUNT_SUMMARY: 'SET_ACCOUNT_SUMMARY',
  SET_AI_SUMMARY: 'SET_AI_SUMMARY',
  SET_BOT_SUMMARY: 'SET_BOT_SUMMARY',
  TOGGLE_ACCOUNT_REPORT_LOADING: 'TOGGLE_ACCOUNT_REPORT_LOADING',
  SET_ACCOUNT_CONVERSATION_METRIC: 'SET_ACCOUNT_CONVERSATION_METRIC',
  TOGGLE_ACCOUNT_CONVERSATION_METRIC_LOADING:
    'TOGGLE_ACCOUNT_CONVERSATION_METRIC_LOADING',
  SET_AGENT_CONVERSATION_METRIC: 'SET_AGENT_CONVERSATION_METRIC',
  TOGGLE_AGENT_CONVERSATION_METRIC_LOADING:
    'TOGGLE_AGENT_CONVERSATION_METRIC_LOADING',

  // Conversation Metadata
  SET_CONVERSATION_METADATA: 'SET_CONVERSATION_METADATA',

  // Conversation Page
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  SET_CONVERSATION_END_REACHED: 'SET_CONVERSATION_END_REACHED',
  CLEAR_CONVERSATION_PAGE: 'CLEAR_CONVERSATION_PAGE',

  // Notification Settings
  SET_USER_NOTIFICATION_UI_FLAG: 'SET_USER_NOTIFICATION_UI_FLAG',
  SET_USER_NOTIFICATION: 'SET_USER_NOTIFICATION',

  // User Typing
  ADD_USER_TYPING_TO_CONVERSATION: 'ADD_USER_TYPING_TO_CONVERSATION',
  REMOVE_USER_TYPING_FROM_CONVERSATION: 'REMOVE_USER_TYPING_FROM_CONVERSATION',

  // Conversation Search
  SEARCH_CONVERSATIONS_SET: 'SEARCH_CONVERSATIONS_SET',
  SEARCH_CONVERSATIONS_SET_UI_FLAG: 'SEARCH_CONVERSATIONS_SET_UI_FLAG',

  // Campaigns
  SET_CAMPAIGN_UI_FLAG: 'SET_CAMPAIGN_UI_FLAG',
  SET_CAMPAIGNS: 'SET_CAMPAIGNS',
  SET_CAMPAIGN_FILTERS: 'SET_CAMPAIGN_FILTERS',
  SET_CAMPAIGN_PENDING_ACTION: 'SET_CAMPAIGN_PENDING_ACTION',
  ADD_CAMPAIGN: 'ADD_CAMPAIGN',
  EDIT_CAMPAIGN: 'EDIT_CAMPAIGN',
  DELETE_CAMPAIGN: 'DELETE_CAMPAIGN',
  UPDATE_CAMPAIGN: 'UPDATE_CAMPAIGN',
  SET_CAMPAIGN_CYCLES: 'SET_CAMPAIGN_CYCLES',

  // Contact notes
  SET_CONTACT_NOTES_UI_FLAG: 'SET_CONTACT_NOTES_UI_FLAG',
  SET_CONTACT_NOTES: 'SET_CONTACT_NOTES',
  ADD_CONTACT_NOTE: 'ADD_CONTACT_NOTE',
  EDIT_CONTACT_NOTE: 'EDIT_CONTACT_NOTE',
  DELETE_CONTACT_NOTE: 'DELETE_CONTACT_NOTE',

  // CSAT Responses
  SET_CSAT_RESPONSE_UI_FLAG: 'SET_CSAT_RESPONSE_UI_FLAG',
  SET_CSAT_RESPONSE: 'SET_CSAT_RESPONSE',
  SET_CSAT_RESPONSE_METRICS: 'SET_CSAT_RESPONSE_METRICS',

  // Custom Attributes
  SET_CUSTOM_ATTRIBUTE_UI_FLAG: 'SET_CUSTOM_ATTRIBUTE_UI_FLAG',
  SET_CUSTOM_ATTRIBUTE: 'SET_CUSTOM_ATTRIBUTE',
  ADD_CUSTOM_ATTRIBUTE: 'ADD_CUSTOM_ATTRIBUTE',
  EDIT_CUSTOM_ATTRIBUTE: 'EDIT_CUSTOM_ATTRIBUTE',
  DELETE_CUSTOM_ATTRIBUTE: 'DELETE_CUSTOM_ATTRIBUTE',

  // Automation Flows (feature unificada)
  SET_AUTOMATION_FLOW_UI_FLAG: 'SET_AUTOMATION_FLOW_UI_FLAG',
  SET_AUTOMATION_FLOWS: 'SET_AUTOMATION_FLOWS',
  ADD_AUTOMATION_FLOW: 'ADD_AUTOMATION_FLOW',
  EDIT_AUTOMATION_FLOW: 'EDIT_AUTOMATION_FLOW',
  DELETE_AUTOMATION_FLOW: 'DELETE_AUTOMATION_FLOW',
  SET_AUTOMATION_FLOW_CATALOG: 'SET_AUTOMATION_FLOW_CATALOG',

  // Diretórios (pastas) de fluxos
  SET_AUTOMATION_FLOW_DIRECTORY_UI_FLAG:
    'SET_AUTOMATION_FLOW_DIRECTORY_UI_FLAG',
  SET_AUTOMATION_FLOW_DIRECTORIES: 'SET_AUTOMATION_FLOW_DIRECTORIES',
  ADD_AUTOMATION_FLOW_DIRECTORY: 'ADD_AUTOMATION_FLOW_DIRECTORY',
  EDIT_AUTOMATION_FLOW_DIRECTORY: 'EDIT_AUTOMATION_FLOW_DIRECTORY',
  DELETE_AUTOMATION_FLOW_DIRECTORY: 'DELETE_AUTOMATION_FLOW_DIRECTORY',

  // Etiquetas de fluxos — catálogo PRÓPRIO (#1197), não o `labels` da conta
  SET_AUTOMATION_FLOW_LABEL_UI_FLAG: 'SET_AUTOMATION_FLOW_LABEL_UI_FLAG',
  SET_AUTOMATION_FLOW_LABELS: 'SET_AUTOMATION_FLOW_LABELS',
  ADD_AUTOMATION_FLOW_LABEL: 'ADD_AUTOMATION_FLOW_LABEL',
  EDIT_AUTOMATION_FLOW_LABEL: 'EDIT_AUTOMATION_FLOW_LABEL',
  DELETE_AUTOMATION_FLOW_LABEL: 'DELETE_AUTOMATION_FLOW_LABEL',

  // Custom Views
  SET_CUSTOM_VIEW_UI_FLAG: 'SET_CUSTOM_VIEW_UI_FLAG',
  SET_CUSTOM_VIEW: 'SET_CUSTOM_VIEW',
  ADD_CUSTOM_VIEW: 'ADD_CUSTOM_VIEW',
  UPDATE_CUSTOM_VIEW: 'UPDATE_CUSTOM_VIEW',
  DELETE_CUSTOM_VIEW: 'DELETE_CUSTOM_VIEW',
  SET_ACTIVE_CONVERSATION_FOLDER: 'SET_ACTIVE_CONVERSATION_FOLDER',

  // Atendente de IA. O nome da flag é resíduo do Typebot, mas ela é a ui-flag
  // genérica do módulo aiAgents — as quatro mutações de lista (SET_TYPEBOTS,
  // ADD/EDIT/DELETE_TYPEBOT) saíram na #732 com a listagem legada.
  SET_TYPEBOT_UI_FLAG: 'SET_TYPEBOT_UI_FLAG',
  SET_VECTOR_STORE_FILES: 'SET_VECTOR_STORE_FILES',
  REMOVE_VECTOR_STORE_FILE: 'REMOVE_VECTOR_STORE_FILE',

  // Bulk Actions
  SET_BULK_ACTIONS_FLAG: 'SET_BULK_ACTIONS_FLAG',

  // Dashboard Apps
  SET_DASHBOARD_APPS_UI_FLAG: 'SET_DASHBOARD_APPS_UI_FLAG',
  SET_DASHBOARD_APPS: 'SET_DASHBOARD_APPS',
  CREATE_DASHBOARD_APP: 'CREATE_DASHBOARD_APP',
  EDIT_DASHBOARD_APP: 'EDIT_DASHBOARD_APP',
  DELETE_DASHBOARD_APP: 'DELETE_DASHBOARD_APP',

  // Help center
  ADD_ARTICLE: 'ADD_ARTICLE',
  ADD_ARTICLE_ID: 'ADD_ARTICLE_ID',
  ADD_MANY_ARTICLES: 'ADD_MANY_ARTICLES',
  ADD_MANY_ARTICLES_ID: 'ADD_MANY_ARTICLES_ID',
  SET_ARTICLES_META: 'SET_ARTICLES_META',
  UPDATE_ARTICLE_FLAG: 'UPDATE_ARTICLE_FLAG',
  ADD_ARTICLE_FLAG: 'ADD_ARTICLE_FLAG',
  UPDATE_ARTICLE: 'UPDATE_ARTICLE',
  CLEAR_ARTICLES: 'CLEAR_ARTICLES',
  REMOVE_ARTICLE: 'REMOVE_ARTICLE',
  REMOVE_ARTICLE_ID: 'REMOVE_ARTICLE_ID',
  SET_UI_FLAG: 'SET_UI_FLAG',

  // Help Center -- Categories
  ADD_CATEGORY: 'ADD_CATEGORY',
  ADD_CATEGORY_ID: 'ADD_CATEGORY_ID',
  ADD_MANY_CATEGORIES: 'ADD_MANY_CATEGORIES',
  ADD_MANY_CATEGORIES_ID: 'ADD_MANY_CATEGORIES_ID',
  ADD_CATEGORY_FLAG: 'ADD_CATEGORY_FLAG',
  CLEAR_CATEGORIES: 'CLEAR_CATEGORIES',
  UPDATE_CATEGORY: 'UPDATE_CATEGORY',
  REMOVE_CATEGORY: 'REMOVE_CATEGORY',
  REMOVE_CATEGORY_ID: 'REMOVE_CATEGORY_ID',

  // Agent Bots
  SET_AGENT_BOT_UI_FLAG: 'SET_AGENT_BOT_UI_FLAG',
  SET_AGENT_BOTS: 'SET_AGENT_BOTS',
  ADD_AGENT_BOT: 'ADD_AGENT_BOT',
  EDIT_AGENT_BOT: 'EDIT_AGENT_BOT',
  DELETE_AGENT_BOT: 'DELETE_AGENT_BOT',
  SET_AGENT_BOT_INBOX: 'SET_AGENT_BOT_INBOX',

  // Full Search
  FULL_SEARCH_SET: 'FULL_SEARCH_SET',
  CONTACT_SEARCH_SET: 'CONTACT_SEARCH_SET',
  CONTACT_SEARCH_SET_UI_FLAG: 'CONTACT_SEARCH_SET_UI_FLAG',
  COMPANY_SEARCH_SET: 'COMPANY_SEARCH_SET',
  COMPANY_SEARCH_SET_UI_FLAG: 'COMPANY_SEARCH_SET_UI_FLAG',
  CONVERSATION_SEARCH_SET: 'CONVERSATION_SEARCH_SET',
  CONVERSATION_SEARCH_SET_UI_FLAG: 'CONVERSATION_SEARCH_SET_UI_FLAG',
  MESSAGE_SEARCH_SET: 'MESSAGE_SEARCH_SET',
  MESSAGE_SEARCH_SET_UI_FLAG: 'MESSAGE_SEARCH_SET_UI_FLAG',
  FULL_SEARCH_SET_UI_FLAG: 'FULL_SEARCH_SET_UI_FLAG',
  SET_CONVERSATION_PARTICIPANTS_UI_FLAG:
    'SET_CONVERSATION_PARTICIPANTS_UI_FLAG',
  SET_CONVERSATION_PARTICIPANTS: 'SET_CONVERSATION_PARTICIPANTS',

  // Audit Logs
  SET_AUDIT_LOGS_UI_FLAG: 'SET_AUDIT_LOGS_UI_FLAG',
  SET_AUDIT_LOGS: 'SET_AUDIT_LOGS',
  SET_AUDIT_LOGS_META: 'SET_AUDIT_LOGS_META',

  // SLA
  SET_SLA_UI_FLAG: 'SET_SLA_UI_FLAG',
  SET_SLA: 'SET_SLA',
  ADD_SLA: 'ADD_SLA',
  EDIT_SLA: 'EDIT_SLA',
  DELETE_SLA: 'DELETE_SLA',

  // SLA Reports
  SET_SLA_REPORTS_UI_FLAG: 'SET_SLA_REPORTS_UI_FLAG',
  SET_SLA_REPORTS: 'SET_SLA_REPORTS',
  SET_SLA_REPORTS_METRICS: 'SET_SLA_REPORTS_METRICS',
  SET_SLA_REPORTS_META: 'SET_SLA_REPORTS_META',

  // Custom Reports
  SET_CUSTOM_REPORTS_UI_FLAG: 'SET_CUSTOM_REPORTS_UI_FLAG',
  SET_CUSTOM_REPORTS: 'SET_CUSTOM_REPORTS',
  ADD_CUSTOM_REPORT: 'ADD_CUSTOM_REPORT',
  EDIT_CUSTOM_REPORT: 'EDIT_CUSTOM_REPORT',
  DELETE_CUSTOM_REPORT: 'DELETE_CUSTOM_REPORT',
  SET_CURRENT_CUSTOM_REPORT: 'SET_CURRENT_CUSTOM_REPORT',

  // Custom Reports Catalog & Widgets
  SET_CUSTOM_REPORTS_CATALOG: 'SET_CUSTOM_REPORTS_CATALOG',
  SET_CUSTOM_REPORTS_WIDGETS: 'SET_CUSTOM_REPORTS_WIDGETS',
  SET_CUSTOM_REPORTS_WIDGETS_RAW: 'SET_CUSTOM_REPORTS_WIDGETS_RAW',
  ADD_CUSTOM_REPORT_WIDGET: 'ADD_CUSTOM_REPORT_WIDGET',
  EDIT_CUSTOM_REPORT_WIDGET: 'EDIT_CUSTOM_REPORT_WIDGET',
  DELETE_CUSTOM_REPORT_WIDGET: 'DELETE_CUSTOM_REPORT_WIDGET',
  SET_CUSTOM_REPORT_RUNS: 'SET_CUSTOM_REPORT_RUNS',
  SET_CURRENT_CUSTOM_REPORT_RUN: 'SET_CURRENT_CUSTOM_REPORT_RUN',
  SET_CUSTOM_REPORT_EXPORTS: 'SET_CUSTOM_REPORT_EXPORTS',
  SET_CURRENT_CUSTOM_REPORT_EXPORT: 'SET_CURRENT_CUSTOM_REPORT_EXPORT',
  ADD_CUSTOM_REPORT_EXPORT: 'ADD_CUSTOM_REPORT_EXPORT',

  // Webphone
  SET_WEBPHONE_UI_FLAG: 'SET_ACCOUNT_UI_FLAG',
  SET_WEBPHONE_CALL: 'SET_WEBPHONE_CALL',
  ADD_WAVOIP: 'ADD_WAVOIP',

  // Conversation Notes
  SET_CONVERSATION_NOTES_UI_FLAG: 'SET_CONVERSATION_NOTES_UI_FLAG',
  SET_CONVERSATION_NOTES: 'SET_CONVERSATION_NOTES',

  // FlipLeads
  SET_FLIP_LEADS_UI_FLAG: 'SET_FLIP_LEADS_UI_FLAG',
  SET_FLIP_LEADS: 'SET_FLIP_LEADS',
  APPEND_FLIP_LEADS: 'APPEND_FLIP_LEADS',
  CLEAR_FLIP_LEADS: 'CLEAR_FLIP_LEADS',
  SET_FLIP_LEADS_META: 'SET_FLIP_LEADS_META',
  SET_FLIP_LEAD_ITEM: 'SET_FLIP_LEAD_ITEM',
  SET_FLIP_LEADS_FACETS: 'SET_FLIP_LEADS_FACETS',
  SET_FLIP_LEADS_FILTERS: 'SET_FLIP_LEADS_FILTERS',
  SET_FLIP_LEADS_CREDITS: 'SET_FLIP_LEADS_CREDITS',
};
